import React from "react";

const MapPoint = ({ color, clickCard, restaurantId }) => {
  let pointColor;
  // if (!color) {
  //   pointColor = "#000000";
  // } else {
  pointColor = "#5b70c7";
  // }

  return (
    <svg
      onClick={e => clickCard(e)}
      width="17px"
      height="21px"
      viewBox="0 0 17 21"
      id={`point-${restaurantId}`}
      className="restaurant-card__map-point-svg"
    >
      <g
        id="Oval-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        className="restaurant-card__map-point-svg"
      >
        <g
          id="Oval-3"
          transform="translate(-565.000000, -567.000000)"
          className="restaurant-card__map-point-svg"
        >
          <g
            id="Oval-4"
            transform="translate(565.000000, 567.000000)"
            className="restaurant-card__map-point-svg"
          >
            <g
              id="Oval-5"
              transform="translate(0.026400, 0.000000)"
              className="restaurant-card__map-point-svg"
            >
              <g
                id="Oval-2"
                fill={pointColor}
                className="restaurant-card__map-point-svg"
              >
                <path
                  d="M8.23284,21.0161952 C10.2877442,18.4272 11.6795593,16.68084 12.4082855,15.7771152 C14.8759037,12.716915 16.46568,10.3252184 16.46568,8.2927152 C16.46568,3.74584322 12.779712,0.0598752 8.23284,0.0598752 C3.68596802,0.0598752 0,3.74584322 0,8.2927152 C0,10.2198179 1.79586214,12.9261393 4.01418733,15.7771152 C4.77570212,16.7558086 6.18191967,18.5021686 8.23284,21.0161952 Z"
                  id="Oval-6"
                  className="restaurant-card__map-point-svg"
                ></path>
              </g>
              <circle
                id="Oval-7"
                fill="#FFFFFF"
                cx="8.23284"
                cy="8.23284"
                r="4.31244"
                className="restaurant-card__map-point-svg"
              ></circle>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MapPoint;
